import {
    mapMutations
} from "vuex";

export default {
    methods: {
        ...mapMutations([
            'SET_SNACKBAR_DATA'
        ]),
        displayErrors(errors) {
            errors.forEach(error => {
                setTimeout(() => {
                    this.SET_SNACKBAR_DATA({
                        type: "error",
                        text: error
                    });
                });
            });
        }
    }
}